import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { MarketplaceSwitch } from 'src/components/profileComponents/Marketplace/components/Common/MarketplaceSwitch';
import { translations } from 'src/constants/translations';
import { BoxFormTextField } from 'src/components/profileComponents/FormTextField';
import {
  UploadMarketplace,
} from 'src/components/profileComponents/Marketplace/components/Filters/components/UploadMarketplace';
import { SubGroupWrapper } from 'src/components/profileComponents/Marketplace/components/SubGroupWrapper';
import {
  useStyles as mainUseStyles,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/Common/styles';
import {
  IMarketplacePlacementCardFooterHoverItemExtended,
} from 'src/typings/marketplaceTile';
import { readURL } from 'src/helpers';
import { updateTranslatedField } from 'src/components/profileComponents/Marketplace/components/Filters/helpers';

interface Props {
  title: string,
  entity: IMarketplacePlacementCardFooterHoverItemExtended,
  onChange: (entity: IMarketplacePlacementCardFooterHoverItemExtended) => void,
  lang: string,
}
export const UnitsCardFooterHoverEntity: React.FC<Props> = ({
  title, entity, onChange, lang,
}) => {
  const [image, setImage] = useState<string | null>(entity.iconFileUri?.fileUrl || null);
  const mainStyles = mainUseStyles();
  return (
    <SubGroupWrapper
      name={title}
      customOffsetStyles={mainStyles.customOffsetStyles}
    >
      <Box display="flex" flex="auto" gap="20px">
        <MarketplaceSwitch
          title="Off/On"
          defaultChecked={entity.isActive}
          onChange={(checked) => {
            onChange({ ...entity, isActive: checked });
          }}
        />
        <UploadMarketplace
          register={() => {}}
          registerName=""
          image={image}
          onUpload={async (file, response) => {
            onChange({ ...entity, iconFileUri: response.data[0] });
            const base64: string = await readURL(file);
            if (base64) {
              setImage(base64);
            }
          }}
          onMoveToTrash={() => {
            onChange({ ...entity, iconFileUri: null });
            setImage(null);
          }}
        />
        <BoxFormTextField
          label={translations.actionButtonName}
          defaultValue={entity.name?.[lang]}
          onChange={(e) => {
            onChange(updateTranslatedField(entity, 'name', lang, e.target.value));
          }}
        />
      </Box>
    </SubGroupWrapper>
  );
};
